"use strict";
/** list of object typeids used on objects which are pseudo properties (and therefore might be processed erroneously as edges ) */
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeObjectTypeIds = void 0;
exports.attributeObjectTypeIds = ['DeviceConfig', 'DeviceControlTransaction', 'Incident', 'ObjectHistory', 'ObservationHistory', 'ThingShadowState'];
